<div class="form-control-feedback">
  <div *ngIf="component.hasErrors()" [id]="component.name + 'Errors'">
    <p *ngFor="let error of errorMessages" class="error" role="alert">
      {{getMessage(error)}}
    </p>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/core/achoo-validation-alerts/achoo-validation-alerts.component.html